import { useGetUserQuery, useUpdateUserMutation } from 'src/redux/Api/userApi'
import style from './style.module.scss'
import { useSelector } from 'react-redux'
import Input from 'src/Components/Form/Input'
import { useEffect, useState } from 'react'
import { IUser } from 'src/utils/Interfaces/user.interface'
import HotelOutlinedIcon from '@mui/icons-material/HotelOutlined'
import FavoriteOutlinedIcon from '@mui/icons-material/FavoriteOutlined'
import noAvatar from 'src/assets/img/no-avatar.png'
import { IState } from 'src/utils/Interfaces/state.interface'

const Profile = () => {
  const { id } = useSelector((state: IState) => state.auth)
  const { data, isLoading } = useGetUserQuery(id || 0)
  const [updateUser] = useUpdateUserMutation()
  const [user, setUser] = useState({} as IUser)
  const [save, setSave] = useState(false)

  useEffect(() => {
    if (data) {
      setUser(data)
    }
  }, [data])

  useEffect(() => {
    if (JSON.stringify(user) !== JSON.stringify(data)) {
      setSave(true)
    } else {
      setSave(false)
    }
  }, [user])

  const saveProfile = async () => {
    await updateUser(user).unwrap()
    setSave(false)
  }

  return (
    <>
      <h1>Profile</h1>
      <div className={style.profile + ' block'}>
        {isLoading ? (
          <p>Loading...</p>
        ) : (
          data && (
            <>
              <div className={style.primary}>
                <h2>General</h2>
                <Input label="Name" value={user.name} name="name" onChange={(e) => setUser({ ...user, name: e.target.value } as IUser)} />
                <Input
                  label="Status"
                  name="status"
                  value={user.status || ''}
                  onChange={(e) => setUser({ ...user, status: e.target.value } as IUser)}
                />
                <Input
                  label="Position"
                  name="position"
                  value={user.position || ''}
                  onChange={(e) => setUser({ ...user, position: e.target.value } as IUser)}
                />
                <Input
                  type="date"
                  label="Start Date"
                  value={user.startWork || ''}
                  name="startDate"
                  onChange={(e) => setUser({ ...user, startDate: e.target.value } as IUser)}
                />
                <Input
                  type="date"
                  label="Birthday"
                  value={user.birthday || ''}
                  name="birthday"
                  onChange={(e) => setUser({ ...user, birthday: e.target.value } as IUser)}
                />

                <h2>About me</h2>
                <Input
                  label="About me"
                  value={user.aboutMe || ''}
                  name="aboutMe"
                  onChange={(e) => setUser({ ...user, aboutMe: e.target.value })}
                />
              </div>
              <div className={style.aside}>
                <div className={style.image}>
                  <img src={user?.avatar || noAvatar} alt="avatar" />
                </div>
                <div className={style.absenсe}>
                  <p>Available days today</p>
                  <ul>
                    <li className={style.vacation}>
                      <HotelOutlinedIcon /> 21
                    </li>
                    <li className={style.sickleave}>
                      <FavoriteOutlinedIcon /> 10
                    </li>
                  </ul>
                </div>
                <h2>Contacts</h2>
                <Input
                  label="Phone"
                  value={user.phone || ''}
                  name="phone"
                  onChange={(e) => setUser({ ...user, phone: e.target.value } as IUser)}
                />
                <Input label="Email" value={user.email} name="email" readOnly />
              </div>
            </>
          )
        )}
        <div className={style.actions}>
          {save && (
            <button className="btn btn-primary" onClick={() => saveProfile()}>
              Save
            </button>
          )}
        </div>
      </div>
    </>
  )
}

export default Profile
